"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sampleReduxContainer_1 = require("./sampleReduxContainer");
exports.SampleReduxContainer = sampleReduxContainer_1.SampleReduxContainer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9yZWR1eC9zYW1wbGUvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrREFBNkQ7QUFBcEQsc0RBQUEsb0JBQW9CLENBQUEifQ==